/**
 * User/auth state slice
 */

/** The logged-in user, as /api/auth/me describes them. */
export interface CurrentUser {
    id?: number;
    email?: string;
    displayName?: string | null;
    fullName?: string | null;
    admin?: boolean;
}

export interface UserState {
    currentUser: CurrentUser | null;
    lichessConnected: boolean;
    lichessUsername: string | null;
}

export const userSlice: UserState = {
    currentUser: null,
    lichessConnected: false,
    lichessUsername: null,
};

/** Check if user is authenticated */
export function isAuthenticated(userState: UserState): boolean {
    return userState.currentUser !== null;
}
